module.exports = __webpack_public_path__ + "static/media/upload.532f3776.svg";